import script from "./SideBarExpandedItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./SideBarExpandedItem.vue?vue&type=script&lang=ts&setup=true"

import "./SideBarExpandedItem.vue?vue&type=style&index=0&id=14c75ec5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14c75ec5"]])

export default __exports__